module.exports = __webpack_public_path__ + "static/media/fichaTecnicaMenorPeso.1ad42a9b.pdf";